import React from 'react';
import { SkeletonText } from '@tvg/fuse/skeleton';
import { Logo } from '@tvg/fuse/logo';
import { MarketingCard } from '@tvg/fuse/marketing-card';
import { SiteName } from 'types/Site';
import BrandTypes from 'constants/brand';
import styles from './SkeletonCard.module.css';

interface SkeletonCardProps {
  site: SiteName;
}

export default function SkeletonCard({ site }: SkeletonCardProps) {
  if (site === BrandTypes.LITTLEWOODS) {
    return (
      <MarketingCard className={styles.card} data-testid="littlewoods-skeleton-card">
        <SkeletonText
          lineHeight="m2"
          margin={{
            top: 'space3',
            bottom: 'space1',
          }}
          width={{
            l: '50%',
            s: '60%',
            m: '60%',
          }}
        />

        <SkeletonText
          lineHeight="m2"
          margin={{
            top: 'space5',
          }}
          width={{
            l: '70%',
            s: '85%',
            m: '85%',
          }}
        />

        <SkeletonText
          lineHeight="m2"
          margin={{
            top: 'space3',
            bottom: 'space1',
          }}
          width={{
            l: '60%',
            s: '70%',
            m: '70%',
          }}
        />

        <span className={styles.divider} />

        <SkeletonText
          className={styles.skeletonLink}
          margin={{
            top: 'space5',
          }}
          width={{
            l: '45%',
            s: '50%',
            m: '50%',
          }}
        />
      </MarketingCard>
    );
  }

  return (
    <MarketingCard className={styles.card} data-testid="verypay-skeleton-card">
      <Logo brand="VeryPay" size={{ width: 88 }} alt="Very Pay" />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space5',
          bottom: 'space1',
        }}
        width={{
          l: '50%',
          s: '60%',
          m: '60%',
        }}
      />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space3',
          bottom: 'space1',
        }}
        width={{
          l: '50%',
          s: '60%',
          m: '60%',
        }}
      />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space3',
        }}
        width={{
          l: '50%',
          s: '60%',
          m: '60%',
        }}
      />

      <SkeletonText
        lineHeight="m2"
        margin={{
          top: 'space6',
          bottom: 'space2',
        }}
        width={{
          l: '55%',
          s: '75%',
          m: '75%',
        }}
      />

      <span className={styles.divider} />

      <SkeletonText
        className={styles.skeletonLink}
        margin={{
          top: 'space5',
        }}
        width={{
          l: '45%',
          s: '50%',
          m: '50%',
        }}
      />
    </MarketingCard>
  );
}
